import { Component, Output, EventEmitter, Input } from "@angular/core";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { FormsModule } from "@angular/forms";

@Component({
   selector: "my-cloud-searchbox",
   template:
      '<input type="text" class="search-input form-control form-control-sm" [placeholder]="placeholder" [ngModel]="displayValue" (focus)="onFocus()" (blur)="onBlur()" (keyup)="onSearch($any($event.target).value)" />',
   styles: [],
   imports: [FormsModule]
})
export class SearchboxComponent {
   private isFocused = false;
   public displayValue?: string;

   // Only resync the displayed value from the parent while the box isn't being actively typed into:
   // the parent echoes this back after every debounced search, which otherwise overwrites in-progress keystrokes.
   @Input() public set searchTerm(value: string | undefined) {
      if (!this.isFocused) {
         this.displayValue = value;
      }
   }

   @Output() public searchTermChanged = new EventEmitter<string>();

   @Input() public placeholder = "Search";

   private readonly searchSubject = new Subject<string>();

   constructor() {
      this.searchSubject.pipe(
         debounceTime(500),
         distinctUntilChanged()
      ).subscribe(searchTerm => {
         this.searchTermChanged.emit(searchTerm);
      });
   }

   public onSearch(value: string): void {
      this.searchSubject.next(value);
   }

   public onFocus(): void {
      this.isFocused = true;
   }

   public onBlur(): void {
      this.isFocused = false;
   }
}
